var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-col", { attrs: { xs: "12" } }, [
    _c("div", { staticClass: "total-box" }, [
      _c("div", { staticClass: "salesItemCount mtl" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.$ctc("item-count-type", _vm.sale.Rows.length, {
                count: _vm.sale.Rows.length,
                type: _vm.sale
                  .getTypeName(_vm.$i18n.locale)
                  .split(" ")[0]
                  .toLowerCase(),
              })
            ) +
            " "
        ),
      ]),
      _c(
        "div",
        { staticClass: "salesTotalExcl row" },
        [
          _vm._v(" " + _vm._s(_vm.$ct("total-exc-vat"))),
          _c("w-spacer"),
          _c("span", { staticClass: "block" }, [
            _vm._v(
              _vm._s(_vm.currencySymbol) +
                " " +
                _vm._s(
                  _vm._f("humanFloat")(
                    _vm.sale.TotalExcVAT / _vm.sale.CurrencyRate
                  )
                )
            ),
          ]),
        ],
        1
      ),
      _vm.sale.TotalLeeggoed != 0
        ? _c(
            "div",
            { staticClass: "salesTotalExcl row" },
            [
              _vm._v(" " + _vm._s(_vm.$ct("total-inc-vat"))),
              _c("w-spacer"),
              _c("span", { staticClass: "block" }, [
                _vm._v(
                  _vm._s(_vm.currencySymbol) +
                    " " +
                    _vm._s(
                      _vm._f("humanFloat")(
                        _vm.sale.TotalIncVAT / _vm.sale.CurrencyRate
                      )
                    ) +
                    " "
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.sale.TotalLeeggoed != 0
        ? _c(
            "div",
            { staticClass: "salesTotalExcl row" },
            [
              _vm._v(" " + _vm._s(_vm.$ct("leeggoed-total"))),
              _c("w-spacer"),
              _c("span", { staticClass: "block" }, [
                _vm._v(
                  _vm._s(_vm.currencySymbol) +
                    " " +
                    _vm._s(_vm._f("humanFloat")(_vm.sale.TotalLeeggoed))
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "salesTotalIncl mb row" },
        [
          _vm._v(" " + _vm._s(_vm.$ct("to-pay"))),
          _c("w-spacer"),
          _c("span", { staticClass: "block" }, [
            _vm._v(
              _vm._s(_vm.currencySymbol) +
                " " +
                _vm._s(
                  _vm._f("humanFloat")(
                    _vm.sale.TotalToPay / _vm.sale.CurrencyRate
                  )
                ) +
                " "
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }